import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Redirect, useParams } from "react-router-dom";
import { setToStorage } from "../../../Common";
import Header from "../../../Header";
import { Loading } from "../../UI";
import * as actionType from "../../../constants";
import action from "../../../Actions";

const SwitchAccount = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  useEffect(() => {
    setToStorage("app_token", params.app_token);
    dispatch({ type: actionType.CLEAR_BOARD_REDUX });
    dispatch(action.fetAllBoards(params.app_token));

    if (params) {
      redirectToBoard();
    }
  }, [params]);

  const redirectToBoard = () => {
    console.log("okok");
    props.history.push("/board/list");
  };
  return (
    <div className="mainContent-panel-wrap" style={{ overflow: "auto" }}>
      <Header
        brecum_name={{ name: "", link: "" }}
        brecum_page={"Switch Account"}
      />
      <Container>sadada</Container>
    </div>
  );
};

export default SwitchAccount;
